import { Observable } from 'rxjs'
import { ACTION_GET_NG_ANS, setStoryAns } from '~/redux/storyData'

/**
 * Get latest story object from Angular and set it to Redux store
 */
const getNgStoryEpic = (
  action$,
  _store,
  { serviceResolver } // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> =>
  action$.ofType(ACTION_GET_NG_ANS).map(() => {
    const ngStory = serviceResolver('storyService').getStorySync()
    // Synchronizing the angular story to redux should not overwrite the isDirty state
    return setStoryAns({
      storyAns: ngStory,
    })
  })

export default getNgStoryEpic
